<template>
  <div class="noData">
    <img
      v-if="!hideImg"
      class=""
      :src="require(`@/assets/${imgName}.png`)"
      alt="">
    <div>{{ text }}</div>
  </div>
</template>

<script>
export default {
  // 暂无数据展示项
  name: 'NoData',
  components: {},
  props: {
    imgName: {
      type: String,
      default: 'nullData'
    },
    hideImg: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: '暂无数据'
    }
  },
  data() {
    return {
    }
  },
  computed: {
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.noData{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #909399;
  &>img{
    width: 200px;
    height: 200px;
  }
}
</style>
